import { action, makeObservable, observable, runInAction } from 'mobx';
import type {
  BatchNewVouchersCreationResultDto,
  BatchOfNewVouchersReqDto,
  VoucherLevelsResDto,
} from '@web/common';
import { setupMobX } from '../../../../util/setupMobX';
import {
  batchCreateVouchers,
  voucherLevels,
} from '../../../../request/authenticated-requests/voucher';

export class VoucherStore {
  @observable public creationResult: null | BatchNewVouchersCreationResultDto =
    null;
  @observable public creationError: null | boolean = null;
  @observable public voucherLevels: null | VoucherLevelsResDto = null;

  constructor() {
    makeObservable(this);
  }

  @action public getVoucherLevels = () => {
    voucherLevels()
      .then((voucherLevels) =>
        runInAction(() => (this.voucherLevels = voucherLevels)),
      )
      .catch((error) => {
        console.error('Error fetching voucher levels:', error);
        runInAction(() => (this.voucherLevels = null));
      });
  };

  @action public batchInsertVouchers = (vouchers: BatchOfNewVouchersReqDto) => {
    batchCreateVouchers(vouchers)
      .then((result) =>
        runInAction(() => {
          this.creationResult = result;
          this.creationError = null;
        }),
      )
      .catch((error) => {
        console.error('here', error);
        runInAction(() => (this.creationError = true));
      });
  };

  @action public clear = () => {
    runInAction(() => {
      this.creationResult = null;
      this.creationError = null;
    });
  };
}
const { provider, useStore } = setupMobX<VoucherStore>();
export const useVoucherStore = useStore;
export const VoucherStoreProvider = provider;
